export default __webpack_public_path__ + "static/media/golf-hand.b429c111.png";